import { FC } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";

import { ModalResetPasswordProps } from "./types";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import { updatePasswordSchema } from "../../utils/validators";
import { updatePasswordUser } from "../../store/auth/slice";
import { selectAuthErrorResetPassword, selectAuthLoadingUpdate } from "../../store/selectors/auth";
import { FormikInputFieldHide } from "../FormikField";

import styles from "./ModalResetPassword.module.css";



const ModalResetPassword: FC<ModalResetPasswordProps> = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const loadingUpdate = useSelector(selectAuthLoadingUpdate);
  const errorResetPassword = useSelector(selectAuthErrorResetPassword);

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Formik
        initialValues={{ oldPassword: '', newPassword: '', confirmPassword: '' }}
        validationSchema={updatePasswordSchema}
        onSubmit={(values) => {
          dispatch(updatePasswordUser({
            oldPassword: values.oldPassword,
            password: values.newPassword,
          }));
        }}
      >
        {() => (
          <Form className={styles.form} autoComplete="off">
            <header className={styles.form__header}>
              <h2 className={styles.form__title}>Change Your Password</h2>
            </header>

            <div className={styles.form__field}>
              <FormikInputFieldHide
                placeholder="Old password"
                name="oldPassword"
              />
            </div>

            <div className={styles.form__field}>
              <FormikInputFieldHide
                placeholder="New password"
                name="newPassword"
              />
            </div>

            <div className={styles.form__field}>
              <FormikInputFieldHide
                placeholder="Confirm password"
                name="confirmPassword"
              />
            </div>

            <footer className={styles.form__footer}>
              <Button
                type="submit"
                label="Confirm"
                typeStyle="fill-dark"
                size="lg"
                className={styles.form__confirm}
                disabled={loadingUpdate}
              />
              <Button
                type="button"
                label="Cancel"
                typeStyle="empty"
                size="lg"
                className={styles.form__cancel}
                onClick={onClose}
              />
            </footer>
            {errorResetPassword && (
              <div className={styles.form__error}>
                <p>{errorResetPassword}</p>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </Modal >
  );
};

export default ModalResetPassword; 